import { render, staticRenderFns } from "./Awb.vue?vue&type=template&id=5b365358"
import script from "./Awb.vue?vue&type=script&lang=js"
export * from "./Awb.vue?vue&type=script&lang=js"
import style0 from "./Awb.vue?vue&type=style&index=0&id=5b365358&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports